function checkBISAvailability() {
    // check if BIS app js is loaded, it will not call the function if interval limit will be reached
    let maximumTry = 0;
    const interval = setInterval(() => {
        if(typeof window.BIS !== 'undefined') {
            clearInterval(interval);
            bisBtnToggle();
        }
        maximumTry++;
        if(maximumTry === 5) clearInterval(interval);
    }, 500)
}


function bisBtnToggle() {
    if(typeof window.BIS !== 'undefined') {
        const buyBtnWrapper = Array.from(document.querySelectorAll('.product-form-wrapper'))
        .filter(form => form.querySelector('.product-form').style.display !== 'none')[0];
        const buyBtn = buyBtnWrapper.querySelector('.product-form__submit');
        const bisBtn = buyBtnWrapper.querySelector('.bis-notify-btn');
        const bisTriger = buyBtnWrapper.querySelector('.bis-trigger-modal');

        const isProductSoldOut = buyBtnWrapper.getAttribute('data-product-soldout') === 'soldout';
        const mobileBarBtn = document.querySelector('.js-main-product .mobile-sticky-bar-wrapper .mobile-sticky-form-btn');
        const mobileBarBisBtn = document.querySelector('.js-main-product .mobile-sticky-bar-wrapper .BIS_trigger');
        if(isProductSoldOut) {
            buyBtn.classList.add('hidden');
            if(bisTriger){
                // trigger the change event to render the active variant size on bis modal on first page load
                document.querySelector('.size-inputs-wrapper')?.querySelector('input:checked')?.dispatchEvent(new Event('change', {bubbles:true}));

                bisTriger.classList.remove('hidden');
                bisBtn.removeAttribute('disabled');
                if(mobileBarBtn && typeof mobileBarBtn !== 'undefined') {
                    mobileBarBtn.classList.add('hidden');
                    mobileBarBisBtn.removeAttribute('disabled');
                    mobileBarBisBtn.classList.remove('hidden');
                }
            }
        }
    }
}

window.addEventListener('load', checkBISAvailability);